import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import {
  AnalyticsState,
  AnalyticsStats,
  AnalyticsStatsResponse
} from './types';
import { baseQuery, endpoints } from 'utils/api/endpoints';
import { startOfDay, sub } from 'date-fns';

export const initialState: AnalyticsState = {

  customDateRange: {
    start: sub(new Date(), { months: 1 }).toISOString().split("T")[0],
    end: startOfDay(new Date()).toISOString(),
  },
  isLoadingProducts: false,
  productsError: null,
  tablePreferences: {
    sortBy: 'productName',
    sortOrder: 'asc',
    pageSize: 20,
    currentPage: 1,
  },
};

const slice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {

    setCustomDateRange(state, action: PayloadAction<{ start: string; end: string } | null>) {
      state.customDateRange = action.payload;
    },
    setTablePreferences(state, action: PayloadAction<Partial<typeof initialState.tablePreferences>>) {
      state.tablePreferences = { ...state.tablePreferences, ...action.payload };
    },
  },
});



export const api = createApi({
  reducerPath: 'analyticsApi',
  baseQuery,
  tagTypes: ['Analytics'],
  endpoints: build => ({
    getAnalytics: build.query<AnalyticsStatsResponse, void>({
      query: () => ({
        url: endpoints.analytics.stats.url,
        method: endpoints.analytics.stats.method,
      }),
    }),
  }),
});

export const { actions } = slice;

export const useAnalyticsSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    actions: slice.actions,
    useGetAnalyticsQuery: api.useGetAnalyticsQuery,
  };
};